import '~/assets/scss/family-fonds.scss';


import getSwiperSlider from '~/js/modules/slider';
import Accordion from '~/js/modules/accordion';
import '~/js/modules/switches';
import Form from '~/js/modules/form';
import '~/js/modules/tabs';


window.addEventListener(`DOMContentLoaded`, () => {
    const bannersSlider = document.querySelector(`.banners__slider`);
    const sliderA = document.querySelector(`.slider-a`);
    const accordions = document.querySelectorAll(`.accordion`);
    const forms = document.querySelectorAll(`.form-b__form`);
    const familyForm = document.querySelector(`.js-form-family`);

    if (forms.length) {
        forms.forEach((form) => new Form(form));
    }

    if (accordions.length) {
        accordions.forEach((accordion) => {
            if (!accordion.classList.contains('main-nav__list')) {
                new Accordion(accordion)
            }
        });
    }
    const interleaveOffset = 0.5;
    if (bannersSlider) {
        const bannersSwiperParams = {
            speed: 1000,
            slidesPerView: 1,
            watchSlidesProgress: true,
            autoplay: {
                delay: 9000,
                waitForTransition: false,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: `.banners .slider-arrows__arrow--next`,
                prevEl: `.banners .slider-arrows__arrow--prev`,
            },
            pagination: {
                el: `.slider-dots`,
                clickable: true,
                bulletClass: `slider-dots__dot`,
                bulletActiveClass: `active`,
                renderBullet(index, className) {
                    return `
                    <button class="${className}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                        <circle cx="50" cy="50" r="25"></circle>
                        </svg>
                    </button>`;
                },
            },
            on: {
                progress() {
                    for (let i = 0; i < this.slides.length; i++) {
                        const slideProgress = this.slides[i].progress;
                        const innerOffset = this.width * interleaveOffset;
                        const innerTranslate = slideProgress * innerOffset;
                        this.slides[i].querySelector(`.slider-top__image`).style.transform = `translate3d(` + innerTranslate + `px, 0, 0)`;
                    }
                },
                touchStart() {
                    this.autoplay.stop();
                    for (let i = 0; i < this.slides.length; i++) {
                        this.slides[i].style.transition = ``;
                    }
                },
                touchEnd() {
                    this.autoplay.start();
                },
                slideChange() {
                    const currentIndex = this.realIndex < 10
                        ? `0${this.realIndex + 1}`
                        : `${this.realIndex + 1}`;
                    this.el.querySelector(`.slider-pages__page--current`).textContent = currentIndex;
                },
                setTransition(speed) {
                    for (let i = 0; i < this.slides.length; i++) {
                        this.slides[i].style.transition = speed + `ms`;
                        this.slides[i].querySelector(`.slider-top__image`).style.transition = speed + `ms`;
                    }
                },
            },
        }
        getSwiperSlider(bannersSlider, bannersSwiperParams);
    };

    const sliderASwiperParams = {
        speed: 1000,
        slidesPerView: 1,
        watchSlidesProgress: true,
        autoplay: {
            delay: 5000,
            waitForTransition: false,
            disableOnInteraction: false,
        },
        spaceBetween: 0,
        navigation: {
            nextEl: `.slider-a .slider-arrows__arrow--next`,
            prevEl: `.slider-a .slider-arrows__arrow--prev`,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
        }
    };

    if (sliderA) {
        getSwiperSlider(sliderA, sliderASwiperParams);
    }

    const mobileSlider = document.querySelector(`.js-mobile-slider`);
    const mobileSliderSwiperParams = {
        slidesPerView: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,

        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    };
    if (window.innerWidth < 1024) {
        getSwiperSlider(mobileSlider, mobileSliderSwiperParams);
    }

    let popup_info = document.querySelectorAll('.js-popup-info')

    if (popup_info) {
        popup_info.forEach((item) => {
            item.addEventListener('mouseover', function () {
                let helpbox = document.createElement("div");
                helpbox.className = 'help-box js-help-box';
                helpbox.innerHTML = item.dataset.popup;
                item.appendChild(helpbox);
            });
            item.addEventListener('mouseout', function () {
                setTimeout(function () {
                    document.querySelectorAll(".js-help-box").forEach((helpbox) => {
                        helpbox.classList.add('help-box-fadeout');
                    })
                }, 500);
            });
        })
    }
    if (familyForm) {
        familyForm.addEventListener('submit', function () {
            const sectionForm = document.querySelector('#beforeform');

            let offsetPosition = sectionForm.getBoundingClientRect().top + document.documentElement.scrollTop;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        })
    }
    //так как слайдер перекрывает стандартный якорь
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView();
        });
    });
});